module.exports = __webpack_public_path__ + "static/media/night_video.9cd93d3e.mp4";